site.spjallmenni = site.spjallmenni || {};

site.spjallmenni = {
	init: function () {
		$(document).ready(function () {
		// Create and load the script
		const script = document.createElement('script');
			script.src = "https://chatbot-api.menni.ai/api/widget?secretKey=sk_cdaf36ec6e529399f1bd3c55d39938be08b3bb03ef8b8f575c195cf9a0f8526f&position=bottom-right";
		script.async = true;

		// Add load event handler
		script.onload = function() {
			console.log('Chatbot widget loaded successfully');
		};

		// Add error event handler
		script.onerror = function(error) {
			console.error('Failed to load chatbot widget', error);
		};

		// Append the script to the document
		document.body.appendChild(script);
		});
	},
};

site.inits.push('site.spjallmenni.init()');
